import React, { useEffect, useState } from 'react';
import { Card, Col, Empty, List, Row, Space, Spin, Statistic, Table, Tag, Typography } from 'antd';
import { getDiscoveryPreview, getHomePreview } from '../../api/operations';

const { Paragraph, Text } = Typography;

const Operations = () => {
  const [loading, setLoading] = useState(true);
  const [homePreview, setHomePreview] = useState(null);
  const [discoveryPreview, setDiscoveryPreview] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [home, discovery] = await Promise.all([
        getHomePreview(),
        getDiscoveryPreview(),
      ]);
      setHomePreview(home);
      setDiscoveryPreview(discovery);
    } catch (error) {
      console.error('Failed to fetch operations preview:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 50 }}>
        <Spin size="large" />
      </div>
    );
  }

  const sectionProductCount = (homePreview?.sections || []).reduce(
    (sum, section) => sum + (section.products?.length || 0),
    0
  );

  return (
    <div>
      <h2>运营预览</h2>

      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col span={6}>
          <Card>
            <Statistic title="Banner 数量" value={homePreview?.banners?.length || 0} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="首页会场区块" value={homePreview?.sections?.length || 0} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="区块商品位" value={sectionProductCount} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="店铺/品牌推荐位" value={(discoveryPreview?.shops?.length || 0) + (discoveryPreview?.brands?.length || 0)} />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Card title="首页摘要">
            <Space direction="vertical" size={8}>
              <Text>任务待办：{homePreview?.taskDigest?.pendingCount || 0}</Text>
              <Text>消息未读：{homePreview?.messageDigest?.unreadCount || 0}</Text>
              <Text>最新消息：{homePreview?.messageDigest?.latestTitle || '暂无'}</Text>
            </Space>
          </Card>
        </Col>
        <Col span={12}>
          <Card title="下一阶段运营能力">
            <List
              size="small"
              dataSource={[
                'Banner 与首页会场配置化编辑',
                '任务中心规则配置与奖励模板',
                '消息通知模版管理与红点监控',
                '品牌专题与店铺会场投放',
              ]}
              renderItem={(item) => <List.Item>{item}</List.Item>}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={14}>
          <Card title="Banner 预览" style={{ height: '100%' }}>
            <Table
              rowKey="id"
              pagination={false}
              dataSource={homePreview?.banners || []}
              locale={{ emptyText: <Empty description="暂无 Banner 数据" /> }}
              columns={[
                { title: '标题', dataIndex: 'title' },
                { title: '副标题', dataIndex: 'subtitle' },
                {
                  title: '目标',
                  render: (_, record) => `${record.targetType || '-'} / ${record.targetValue || '-'}`,
                },
              ]}
            />
          </Card>
        </Col>
        <Col span={10}>
          <Card title="会场区块预览" style={{ height: '100%' }}>
            <List
              dataSource={homePreview?.sections || []}
              locale={{ emptyText: '暂无区块数据' }}
              renderItem={(section) => (
                <List.Item>
                  <List.Item.Meta
                    title={
                      <Space>
                        <span>{section.title}</span>
                        {section.tag ? <Tag color="blue">{section.tag}</Tag> : null}
                      </Space>
                    }
                    description={`${section.subtitle || '暂无副标题'} · ${section.products?.length || 0} 个商品位`}
                  />
                </List.Item>
              )}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col span={12}>
          <Card title="店铺推荐">
            <List
              dataSource={discoveryPreview?.shops || []}
              locale={{ emptyText: '暂无店铺推荐' }}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    title={<Space><span>{item.name}</span><Tag>{item.platform}</Tag></Space>}
                    description={item.slogan || item.targetKeyword}
                  />
                </List.Item>
              )}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="品牌推荐">
            <List
              dataSource={discoveryPreview?.brands || []}
              locale={{ emptyText: '暂无品牌推荐' }}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    title={<Space><span>{item.name}</span><Tag>{item.platform}</Tag></Space>}
                    description={item.slogan || item.targetKeyword}
                  />
                </List.Item>
              )}
            />
          </Card>
        </Col>
      </Row>

      <Card title="说明" style={{ marginTop: 16 }}>
        <Paragraph style={{ marginBottom: 0 }}>
          当前页面先承接 P0/P1 的运营预览职责，帮助运营查看首页导购位、店铺品牌推荐和增长摘要。后续如果要走到“可配置运营台”，建议在这里继续补 Banner 编辑、会场投放、任务模板和消息模板管理。
        </Paragraph>
      </Card>
    </div>
  );
};

export default Operations;
